import React from "react";

export default function GatewayIdentityField({
  label = "Clikkle ID",
  suffix = "@clikkmail.com",
  error,
  className = "",
  ...inputProps
}) {
  const id = inputProps.id || inputProps.name || "clikkle-id";
  const errorId = error ? `${id}-error` : undefined;

  return (
    <div className={["gatewayIdentityField", error ? "gatewayIdentityField--error" : "", className].filter(Boolean).join(" ")}>
      <label className="srOnly" htmlFor={id}>{label}</label>
      <input
        {...inputProps}
        id={id}
        aria-invalid={Boolean(error)}
        aria-describedby={errorId}
      />
      <span className="gatewayIdentityField__suffix" aria-hidden="true">{suffix}</span>
      {error ? <span id={errorId} className="gatewayError gatewayIdentityField__error" role="alert">{error}</span> : null}
    </div>
  );
}
